import React from "react";
import {Spinner} from "reactstrap";

const SmallSpinner = ({ color = "info"}) => {

    return <Spinner size="sm" className="mx-auto" color={color} />
}

export default SmallSpinner;